import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Table } from "reactstrap";
import { PageLength } from "./PageLength";
import { PAGELENGTH } from "./ListLayout";
import Pagination from "components/Pagination";
import { useDispatch } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";

const EditableTable = ({
    tableData,
    handleCellDataChange,
    title,
    noOfItems,
    hidePageLength,
    tableHide,
    renderTableHeader,
    editableCells,
    hidePagination,
    currentPage,
    totalPages,
    setCurrentPage,
    fetchList,
    handleCheckBoxChange,
    selectedItems,
    submitChangedCell,
    renderFooter,
    hideRemoveButton = true,
    specificPageLength
}) => {

    const dispatch = useDispatch()
    const [pageLength, setPageLength] = React.useState(specificPageLength || PAGELENGTH)

    const [editingCell, setEditingCell] = React.useState(null);

    const handlePageLength = React.useCallback((length) => {
        setPageLength(length)
        dispatch(fetchList(currentPage, {   pageLength: length }));
    }, [ currentPage])



    const handleCellClick = (rowId, columnKey) => {
        // Check if the cell is in the editable list
        if (
            !editableCells.some(
                (cell) => cell?.columnKey === columnKey
            )
        ) {
            return;
        }
        setEditingCell({ rowId, columnKey });
    };


    const handlePageChange = React.useCallback((page) => {
        setCurrentPage(page);
        const disableLoader = true;
        dispatch(fetchList(page, {}, disableLoader));
    }, [])


    const handleBlur = (id) => {
        setEditingCell(null); // Exits editing mode on blur
        submitChangedCell(id)

    };


    return (
        <div className="card_table">
            <div className="row_table_head">

                <div className="flex align-items-start flex-column">
                    {title && <h3 className="sub_heading mb-3" >{title}</h3>}
                    {!hidePageLength &&
                        <PageLength handlePageLength={handlePageLength} pageLength={tableHide ? 0 : pageLength} total={noOfItems} />}
                </div>
            </div>

            {/* <div className="row_table_head" style={{ alignItems: "center", padding: 0 }} >
                {hideRemoveButton && <div className="mx-4">
                </div>}
                {renderFooter && renderFooter()}
            </div> */}
            <div className='table_responsive'>
                <Table>
                    {renderTableHeader()}
                    <tbody>
                        {tableData.map((row, index) => (
                            <tr key={row.id}>
                                <td>
                                    <div className="row_check">
                                        <span>{index + 1}</span>
                                    </div>
                                </td>
                                {/* <td>
                                    <div className="row_check">
                                        <label className="custom-checkbox checkbox">
                                            <input type="checkbox" name="select-all" data-value={row.id} checked={
                                                selectedItems.includes(row?.id?.toString()) || row?.verified == 1
                                            } onChange={handleCheckBoxChange} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                </td> */}
                                {Object.keys(row).map(
                                    (key) =>
                                        key !== "id" && (
                                            <td
                                                key={key}
                                                onClick={() => handleCellClick(row.id, key)}
                                                style={{
                                                    cursor: editableCells.some(
                                                        (cell) =>
                                                            cell?.columnKey === key
                                                    )
                                                        ? "pointer"
                                                        : "",
                                                }}
                                            >
                                                {editingCell?.rowId === row.id &&
                                                    editingCell?.columnKey === key ? (
                                                    editableCells?.find(c => c?.columnKey === key)?.inputType ?
                                                        <div className="input-image invoice-time-input">
                                                            <input type="time" placeholder='Start Date'
                                                                // value={row[key]}
                                                                value={moment(row[key], ["h:mm A"]).format("HH:mm")}
                                                                onChange={(e) => {
                                                                    handleCellDataChange(row.id, key, e.target.value)
                                                                }
                                                                }

                                                                onBlur={() =>handleBlur(row?.invoice_id)}
                                                                autoFocus
                                                            />
                                                            <img src="/images/clock.png" alt="celender Icon" className="custom-icon" />

                                                        </div>
                                                        :
                                                        <input
                                                            type={
                                                                key == "rate" ? "number" : "text"
                                                            }
                                                            className="form-control"
                                                            value={row[key]}
                                                            onChange={(e) =>
                                                                handleCellDataChange(row.id, key, e.target.value)
                                                            }
                                                            onBlur={() =>handleBlur(row?.invoice_id)}
                                                            autoFocus
                                                            placeholder="Value"
                                                        />
                                                ) : (

                                                    // (key == "start_time" || key == "end_time") ? moment(row[key], ["HH:mm:ss"]).format("HH:mm") :  row[key]
                                                    (key == "start_time" || key == "end_time") ?
                                                        (row[key] ? moment(row[key], ["HH:mm:ss"]).format("HH:mm") : '') :
                                                        key == "total" ?

                                                            row[key] && <span className="text-nowrap">{`$ ${row[key]}`}</span>
                                                            :

                                                            key == "appid" ?

                                                                <Link className='link_preview' to={`/appointments/view/${row?.id}`}>
                                                                    {row[key]}
                                                                </Link>

                                                                : key !== "verified" && row[key]
                                                )}
                                            </td>
                                        )
                                )}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            <div className="row_end justify-content-between">
                <div className="">
                    {/* {!hidePagination && renderPagination()} */}
                    {(!tableHide && !hidePagination) && <Pagination
                        totalItems={noOfItems}
                        currentPage={currentPage}
                        pageLength={pageLength}
                        totalPages={totalPages}
                        handleChange={handlePageChange}
                        prevDisabled={totalPages <= 1 || currentPage == 1}
                        nextDisabled={totalPages <= 1 || currentPage == totalPages}
                    />}
                </div>

                {/* {hideRemoveButton || selectedItems.length > 0 && <div className="row_end float-right" style={{
                            display: showRemoveOnTop ? "none" : "flex"
                        }}>
                            <button onClick={showConfirmDialog} className="table_delete">Delete</button>
                        </div>} */}

            </div>
        </div>
    );
};

export default EditableTable;
